import React from 'react';
import { Link } from 'react-router-dom';
import { BaseProps } from '@make-software/cspr-ui';
import styled from 'styled-components';
import { useRouteMatchPath } from '../../router/utils';

interface HistoryLinkProps extends BaseProps {
  href: string;
}

const StyledWrapper = styled.span(({ theme }) => ({
  color: theme.styleguideColors.contentBlue,
  '& > *': {
    color: theme.styleguideColors.contentBlue,
  },
  '&:hover > *': {
    color: theme.styleguideColors.fillPrimaryRed,
  },
  '&:active > *': {
    color: theme.styleguideColors.fillPrimaryRedClick,
  },
}));

export const HistoryLink = ({ href, children }: HistoryLinkProps) => {
  const match = useRouteMatchPath();

  return (
    <StyledWrapper>
      <Link
        to={href}
        state={{
          prevRouteMatch: match,
          allowedGoBack: true,
        }}
      >
        {children}
      </Link>
    </StyledWrapper>
  );
};
